export const mockSummary = {
  portfolioId: 'default',
  mode: 'PAPER',
  period: '30d',
  currentEquityUsd: 128420,
  totalPnlUsd: 28420,
  periodPnlUsd: -3210,
  periodPnlPct: -2.44,
  ethBenchmarkPct: -5.1,
  btcBenchmarkPct: -3.8,
  benchmarkDeltaPct: 2.66,
  winRatePct: 58,
  openPositionsCount: 4,
  blockedActionsCount: 6,
  riskMode: 'SELECTIVE',
  largestThesis: 'Whale accumulation',
  primaryBlockedReason: 'INSUFFICIENT_LIQUIDITY',
  verdictText: 'Agent paper portfolio is down 2.4% over 30 days but outperforming ETH by 2.7%. Current mode: selective.',
};

export const mockPerformance = {
  period: '30d',
  series: Array.from({ length: 30 }).map((_, index) => {
    const progress = index / 29;
    const wave = Math.sin(index / 4) * 900;
    const equityUsd = 100000 + progress * 28420 - (index > 20 ? (index - 20) * 500 : 0) + wave;
    return {
      time: new Date(Date.now() - (29 - index) * 24 * 3600 * 1000).toISOString(),
      equityUsd,
      ethBenchmarkUsd: 100000 * (1 - 0.051 * progress),
      btcBenchmarkUsd: 100000 * (1 - 0.038 * progress),
      drawdownPct: index > 22 ? -2.4 : 0,
    };
  }),
  markers: [
    { time: new Date(Date.now() - 18 * 24 * 3600 * 1000).toISOString(), type: 'ACTION_APPROVED', actionId: 'demo-buy-1', label: 'BUY XYZ', status: 'APPROVED' },
    { time: new Date(Date.now() - 8 * 24 * 3600 * 1000).toISOString(), type: 'ACTION_BLOCKED', actionId: 'demo-block-1', label: 'BLOCK ABC', status: 'BLOCKED' },
  ],
};

export const mockLifecycle = {
  period: '30d',
  stages: [
    { stage: 'DETECTED', count: 42 },
    { stage: 'STORY', count: 18 },
    { stage: 'THESIS', count: 9 },
    { stage: 'PROPOSED', count: 5 },
    { stage: 'RISK_CHECKED', count: 5 },
    { stage: 'APPROVED', count: 2 },
    { stage: 'EXECUTED', count: 1 },
    { stage: 'MONITORED', count: 7 },
    { stage: 'CLOSED', count: 3 },
    { stage: 'BLOCKED', count: 6 },
    { stage: 'ABSTAINED', count: 14 },
  ],
};

export const mockAttribution = {
  period: '90d',
  groupBy: 'thesis',
  rows: [
    { name: 'Whale accumulation', agent: 'Whale Tracker', pnlUsd: 4820, pnlPct: 8.2, benchmarkDeltaPct: 3.1, actionCount: 6, winRatePct: 67, avgHoldMinutes: 180, avgConfidence: 72, status: 'WINNER' },
    { name: 'New token anomaly', agent: 'E3D Screener', pnlUsd: -1240, pnlPct: -3.4, benchmarkDeltaPct: -1.2, actionCount: 4, winRatePct: 25, avgHoldMinutes: 90, avgConfidence: 61, status: 'LOSER' },
    { name: 'Liquidity expansion', agent: 'Flow Analyst', pnlUsd: 2110, pnlPct: 5.1, benchmarkDeltaPct: 1.7, actionCount: 3, winRatePct: 66, avgHoldMinutes: 240, avgConfidence: 69, status: 'WINNER' },
    { name: 'Contract-risk filter', agent: 'Risk Sentinel', pnlUsd: 980, pnlPct: 2.9, benchmarkDeltaPct: 1.1, actionCount: 8, winRatePct: 62, avgHoldMinutes: 0, avgConfidence: 65, status: 'WINNER' },
    { name: 'Late breakout chase', agent: 'Momentum Guard', pnlUsd: -880, pnlPct: -2.1, benchmarkDeltaPct: -1.6, actionCount: 5, winRatePct: 40, avgHoldMinutes: 72, avgConfidence: 58, status: 'LOSER' },
    { name: 'Fresh liquidity migration', agent: 'Flow Analyst', pnlUsd: 1430, pnlPct: 4.4, benchmarkDeltaPct: 2.2, actionCount: 4, winRatePct: 75, avgHoldMinutes: 132, avgConfidence: 71, status: 'WINNER' },
    { name: 'Weak market structure', agent: 'Risk Sentinel', pnlUsd: -520, pnlPct: -1.8, benchmarkDeltaPct: -0.9, actionCount: 7, winRatePct: 43, avgHoldMinutes: 0, avgConfidence: 55, status: 'LOSER' },
  ],
};

export const mockBlockedActions = {
  period: '30d',
  rows: [
    { time: new Date(Date.now() - 6 * 3600 * 1000).toISOString(), symbol: 'XYZ', intendedAction: 'BUY', agent: 'Whale Tracker', thesis: 'Whale accumulation but thin exit liquidity.', reason: 'INSUFFICIENT_LIQUIDITY', confidence: 72, afterOutcome: 'Pending outcome tracking', actionId: 'demo-block-1', detailUrl: '/agent-verdicts?action_id=demo-block-1' },
    { time: new Date(Date.now() - 30 * 3600 * 1000).toISOString(), symbol: 'ABC', intendedAction: 'ABSTAIN', agent: 'Risk Sentinel', thesis: 'Momentum conflicted with contract risk.', reason: 'CONTRACT_RISK', confidence: 64, afterOutcome: 'Pending outcome tracking', actionId: 'demo-abstain-1', detailUrl: '/agent-verdicts?action_id=demo-abstain-1' },
  ],
};

export const mockActivity = {
  rows: [
    { time: new Date(Date.now() - 12 * 60 * 1000).toISOString(), type: 'ACTION_BLOCKED', symbol: 'XYZ', agent: 'Whale Tracker', confidence: 72, riskCheck: 'blocked due to insufficient liquidity', summary: 'Accumulation detected, but exit depth was not admissible.', detailUrl: '/agent-verdicts?action_id=demo-block-1' },
    { time: new Date(Date.now() - 48 * 60 * 1000).toISOString(), type: 'ACTION_APPROVED', symbol: 'LQD', agent: 'Flow Analyst', confidence: 76, riskCheck: 'approved', summary: 'Liquidity expansion aligned with flow and price confirmation.', detailUrl: '/agent-verdicts?action_id=demo-buy-1' },
  ],
};
